site.contentImage = {
	figcaption: function() {
		$(window).on('load', function() {
			$('.entryContent').find("img[title]").each(function () {
				var $this = $(this),
					caption = $this.attr('title');
				if (caption !== '' && caption !== undefined) {
					var imgClass = $this.attr('class');
					$this.wrap('<figure />');
					var $figure = $this.closest('figure');

					if (imgClass) {
						$figure.addClass(imgClass);
						$this.removeAttr('class');
					}
					$figure.css('max-width', $this.width());
					$("<figcaption>" + caption + "</figcaption>").insertAfter(this);
				}
			});
		});
	}
};

site.inits.push('site.contentImage.figcaption()');
